import {Card} from "react-bootstrap";
import React from "react";
import SummaryTable from "./SummaryTable";

function ServiceSummaryTable({data}) {
    // console.log(data);


    const headers = [
        {id: 1, key: "stationName", label: "Meter Name"},
        {id: 2, key: "niagaraVersion", label: "Building"},
        {id: 3, key: "uptime", label: "Type"},
        {id: 4, key: "cpu", label: "Current Demand"},
        {id: 5, key: "heap", label: "Stale Data %"},
        {id: 6, key: "downDeviceCount", label: "Down Fault %"},
        {id: 7, key: "overrides", label: "Erratic Index"},
        {id: 8, key: "kpi", label: "KPI"}

    ];


    function exportCSV(fileName) {

        var itemsNotFormatted = data;
        var itemsFormatted = [];

        // format the data
        itemsNotFormatted.forEach((item) => {
            itemsFormatted.push({
                stationName: item.stationName,
                niagaraVersion: item.niagaraVersion,
                cpu: item.cpu,
                // diskTotal: item.diskTotal,
                // diskUsage: item.diskUsage,
                downDeviceCount: item.downDeviceCount,
                // errors: item.errors,
                heap: item.heap,
                hostId: item.hostId,
                kpi: item.kpi,

                overrides: item.overrides,
                // smaExpires: item.smaExpires,
                status: item.status,
                // totalDeviceCount: item.totalDeviceCount,
                uptime: item.uptime
            });
        });

        var items = itemsFormatted;

        var headers = {
            stationName: "Meter Name",
            niagaraVersion: "Building",
            cpu: "Current Demand",
            // diskTotal: "Disk Total",
            // diskUsage: "Disk Usage",
            downDeviceCount: "Down Fault %",
            // errors: "Error Count",
            heap: "Stale Data %",
            hostId: "Host ID",
            kpi: "KPI",

            overrides: "Erratic Index",
            // smaExpires: "SMA Expires",
            status: "Status",
            // totalDeviceCount: "Total Device Count",
            uptime: "Type"
        };

        var fileTitle = fileName; // or 'my-unique-title'

        if (headers) {
            items.unshift(headers);
        }

        // Convert Object to JSON
        var jsonObject = JSON.stringify(items);

        var csv = convertToCSV(jsonObject);

        var exportedFilename = fileTitle + ".csv" || "export.csv";

        var blob = new Blob([csv], {type: "text/csv;charset=utf-8;"});
        // @ts-ignore
        if (navigator.msSaveBlob) {
            // IE 10+
            // @ts-ignore
            navigator.msSaveBlob(blob, exportedFilename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) {
                // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilename);
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    function convertToCSV(objArray) {
        var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
        var str = "";

        for (var i = 0; i < array.length; i++) {
            var line = "";
            for (var index in array[i]) {
                if (line != "") line += ",";

                line += array[i][index];
            }

            str += line + "\r\n";
        }

        return str;
    }



    return (


        <Card bg="light" className="m-2 overflow-hidden" style={{height: '24rem'}}><Card.Body
            className="fs-4 py-1 summary-table">
            <Card.Subtitle className="float-end text-muted text-decoration-underline export-button p-2" onClick={() => {
                exportCSV("data");
            }}>
                <div>
                    <i className="fa fa-download p-1"/>
                    Export
                </div>

            </Card.Subtitle>

            <Card.Title className="fw-bold px-2 pt-1 mb-0 fs-3 text-center dash-title">
                Meter Summary

            </Card.Title>


            <SummaryTable
                data={data}
                headers={headers}
            ></SummaryTable>

        </Card.Body>


        </Card>


    )
        ;
}

// @ts-ignore
export default ServiceSummaryTable;